export const getErrorSignature = (error: unknown): string => {
  try {
    if (error instanceof Error) {
      const message = error.message || 'no-message';
      const stack = error.stack ? error.stack.split('\n').slice(0, 5).join('|') : 'no-stack';

      return `${message}::${stack}`;
    }

    return String(error);
  } catch {
    return 'signature-failed';
  }
};
